import React from 'react'

function InsPection() {
  return (
    <div className='nav-margin'>InsPection</div>
  )
}

export default InsPection